import {
  readUser,
  editUser,
  createUser,
  deleteUser,
} from "~/shared/userAbiltities"

export const useUserPermissions = async () => {
  const canReadUser = await allows(readUser)
  const canEditUser = await allows(editUser)
  const canCreateUser = await allows(createUser)
  const canDeleteUser = await allows(deleteUser)

  return { canReadUser, canEditUser, canCreateUser, canDeleteUser }
}
